import { Dialog, styled } from "@mui/material";
import * as React from "react";
import { useContext, useState } from "react";

import { AppContext } from "../../context/app-context";
import UploadProvider from "../../providers/upload-provider";
import { Roles } from "../../types/roles";

import UploadModalContent from "./content";
import UploadModalFooter from "./footer";
import UploadModalHeader from "./header";
import TriggerButton from "./trigger-button";

export default function UploadModal(): React.ReactElement {
  const [toggle, setToggle] = useState(false);

  const { role } = useContext(AppContext);

  function toggleModal(): void {
    setToggle(!toggle);
  }

  // ToDo: Check roles and only display with the allowed role the upload button
  if (role === Roles.regular) {
    return <></>;
  }

  return (
    <UploadProvider>
      <TriggerButton onClick={toggleModal} />
      <BootstrapDialog
        onClose={toggleModal}
        aria-labelledby="customized-dialog-title"
        open={toggle}
        className="rounded-[15px]"
      >
        <UploadModalHeader onClose={toggleModal} />
        <UploadModalContent />
        <UploadModalFooter onClose={toggleModal} />
      </BootstrapDialog>
    </UploadProvider>
  );
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "10px",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
